import { Input } from '@/components/ui/input'
import { Textarea } from '@/components/ui/textarea'
import { Label } from '@/components/ui/label'

interface Step1BasicInfoProps {
  name: string
  description: string
  onNameChange: (value: string) => void
  onDescriptionChange: (value: string) => void
  errors: {
    name?: string
  }
}

const MAX_NAME_LENGTH = 128
const MAX_DESCRIPTION_LENGTH = 500

export function Step1BasicInfo({
  name,
  description,
  onNameChange,
  onDescriptionChange,
  errors,
}: Step1BasicInfoProps) {
  return (
    <div className="space-y-6">
      <div>
        <h3 className="text-lg font-semibold mb-1">Basic Information</h3>
        <p className="text-sm text-muted-foreground">
          Give your knowledge base a meaningful name and description to help your team identify it.
        </p>
      </div>

      {/* Name Field */}
      <div className="space-y-2">
        <Label htmlFor="name">
          Knowledge Base Name <span className="text-destructive">*</span>
        </Label>
        <Input
          id="name"
          placeholder="e.g., Product Documentation, HR Policies"
          value={name}
          onChange={(e) => onNameChange(e.target.value.slice(0, MAX_NAME_LENGTH))}
          className={errors.name ? 'border-destructive' : ''}
        />
        <div className="flex justify-between text-xs">
          {errors.name ? (
            <span className="text-destructive">{errors.name}</span>
          ) : (
            <span className="text-muted-foreground">
              A unique name for this knowledge base within your organization.
            </span>
          )}
          <span className="text-muted-foreground">
            {name.length}/{MAX_NAME_LENGTH}
          </span>
        </div>
      </div>

      {/* Description Field */}
      <div className="space-y-2">
        <Label htmlFor="description">Description</Label>
        <Textarea
          id="description"
          placeholder="Describe the type of content this knowledge base will contain..."
          value={description}
          onChange={(e) => onDescriptionChange(e.target.value.slice(0, MAX_DESCRIPTION_LENGTH))}
          rows={4}
        />
        <div className="flex justify-between text-xs text-muted-foreground">
          <span>Helps your team understand the purpose of this knowledge base.</span>
          <span>{description.length}/{MAX_DESCRIPTION_LENGTH}</span>
        </div>
      </div>
    </div>
  )
}
